import React from "react";
import {
  buildHistoryColumns,
  buildEventsTableColumns,
  buildPerformanceReportColumns,
  buildInitialFinalFuelColumns,
  buildChargesDischargesColumns,
  buildIddleColumns,
  buildConsumedFuelColumns,
  buildSummaryBehaviorColumns
} from "./builders";
import { Redirect } from "react-router-dom";
import Grid from "material-ui/Grid";
import Paper from "material-ui/Paper";
import Typography from "material-ui/Typography";

import AlertMessage from "../../components/AlertMessage/AlertMessage";
import MediaCard from "./../../components/MediaCard/MediaCard";
import SummaryCard from "./../../components/SummaryCard/SummaryCard";
import LinearLoader from "./../../components/LinearLoader/LinearLoader";
import UnitsTable from "./../../components/UnitsTable/UnitsTable";
import DatetimePicker from "./../../components/DatetimePicker/DatetimePicker";
import GrowTransition from "./../../components/GrowTransition/GrowTransition";
import Sequence from "./../../utilities/sequence";
import { formatDateTimeString } from "../../utilities/datesFormatter";

// import TiempoMuertoFuel from "./../../images/fuel/tiempo-muerto-fuel.jpg";
import SummaryTripsImage from "./../../images/driving/summary-trips.png";
import SummarySpeedImage from "./../../images/driving/summary-speed.png";
import StartImage from "./../../images/start-marker.png";
import EndImage from "./../../images/end-marker.png";
import TimeMovingImage from "./../../images/fuel/Tmovimiento-01.svg";
import BrutePerformanceImage from "./../../images/fuel/bruto-01.svg";
import EfectivePerformanceImage from "./../../images/fuel/efectivo-01.svg";
import DeadTimeImage from "./../../images/fuel/tdetenido-01.svg";
import FetchButton from "../../components/FetchButton/FetchButton";
import DownloadAs from "../../components/DownloadAs/DownloadAs";
import FuelCostInput from "../../components/FuelCostInput/FuelCostInput";
import { FuelChart } from "../../charts/index";
import FilterTable from "../../components/FilterTable/FilterTable";

import "react-table/react-table.css";
import "./Fuel.css";
import TagSelector from "../../components/TagSelector/TagSelector";

const FuelView = props => {
  const {
    lang,
    units,
    unitType,
    isLoading,
    permissions,
    loadedPermissions,
    hasData,
    fetchFuelData,
    isIndividualReport,
    isStationary,
    isNoConsume,
    thereAreNoRegularUnits,
    thereAreOnlyRegularUnits,
    performance,
    events,
    behavior,
    history,
    summaryBehavior,
    initialFuel,
    finalFuel,
    charges,
    discharges,
    iddleFuel,
    consumedFuel,
    volumeUnit,
    distanceUnit,
    downloadExcel,
    downloadPDF,
    alertMessage,
    isAlertMessageOpen,
    handleCloseAlertMessage,
    currency,
    maxVolume,
    individualReportUnit,
    lastLocationDate,
    firstLocationDate
  } = props;

  const fechaPrimerUbicacion = formatDateTimeString(firstLocationDate);
  const fechaUltimaUbicacion = formatDateTimeString(lastLocationDate);

  let performanceReportColumns;
  if (hasData) {
    performanceReportColumns = buildPerformanceReportColumns(
      lang,
      currency,
      volumeUnit
    );
  }

  let historyColumns;
  let eventsColumns;
  let initialFuelColumns;
  let finalFuelColumns;
  let chargesColumns;
  let dischargesColumns;
  let iddleColumns;
  let consumedColumns;
  let summaryBehaviorColumns;
  if (hasData && isIndividualReport) {
    historyColumns = buildHistoryColumns(lang, distanceUnit, volumeUnit);
    eventsColumns = buildEventsTableColumns(lang, currency, volumeUnit);
  } else if (hasData && !isIndividualReport) {
    initialFuelColumns = buildInitialFinalFuelColumns(
      lang,
      currency,
      volumeUnit
    );
    finalFuelColumns = buildInitialFinalFuelColumns(lang, currency, volumeUnit);
    chargesColumns = buildChargesDischargesColumns(lang, currency, volumeUnit);
    dischargesColumns = buildChargesDischargesColumns(
      lang,
      currency,
      volumeUnit
    );
    iddleColumns = buildIddleColumns(lang, currency, volumeUnit);
    consumedColumns = buildConsumedFuelColumns(lang, currency, volumeUnit);
    summaryBehaviorColumns = buildSummaryBehaviorColumns(lang);
  }

  const sequence = new Sequence(0, 50);
  const duration = 50;

  return (
    <div className="fuel">
      {loadedPermissions && !permissions.Fuel && <Redirect to={"./"} push />}

      {isLoading && <LinearLoader />}
      <div className="root">
        <Grid container spacing={24}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="grid-item"
          >
            <DownloadAs
              disabled={!(hasData && !isLoading)}
              xls={true}
              pdf={true}
              xlsClick={downloadExcel}
              pdfClick={downloadPDF}
            />
            <TagSelector />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="grid-item"
          >
            <UnitsTable units={units} />
          </Grid>
        </Grid>
      </div>

      <div className="root">
        <Grid container spacing={24}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="grid-item"
          >
            <Paper className="margin-top-bottom rounded" elevation={4}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="grid-item"
                >
                  <DatetimePicker />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={3}
                  lg={3}
                  xl={3}
                  className="grid-item"
                >
                  <Typography
                    align="center"
                    variant="subheading"
                    color="primary"
                  >
                    <b>{lang.CostoDelCombustible}</b>
                  </Typography>

                  <Grid container>
                    <FuelCostInput />
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={3}
                  lg={3}
                  xl={3}
                  className="grid-item"
                >
                  <div className="fetch-button-container">
                    <FetchButton
                      disabled={isLoading}
                      onClick={fetchFuelData}
                      text={lang.Consultar}
                    />
                  </div>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </div>

      {hasData && (
        <div className="root">
          <Grid container spacing={24}>
            <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              item
              className="grid-item"
            >
              <Typography
                variant="headline"
                align="center"
                color="primary"
                className="headline"
              >
                {isIndividualReport === undefined
                  ? unitType === ""
                    ? individualReportUnit.Descripcion
                    : `${individualReportUnit.Descripcion} (${unitType})`
                  : lang.Resumen}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="grid-item"
            >
              <GrowTransition
                in={!isLoading}
                delay={sequence.next()}
                duration={duration}
              >
                <Paper className="summary rounded" elevation={4}>
                  <Grid container spacing={8}>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.Inicio}
                        value={fechaPrimerUbicacion[0]}
                        units={fechaPrimerUbicacion[1]}
                        imageUrl={StartImage}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.Fin}
                        value={fechaUltimaUbicacion[0]}
                        units={fechaUltimaUbicacion[1]}
                        imageUrl={EndImage}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.VelocidadMaxima}
                        value={
                          isStationary && isIndividualReport
                            ? "N/A"
                            : behavior.VelocidadMaxima
                        }
                        units={
                          isStationary && isIndividualReport
                            ? ""
                            : `${distanceUnit}/h`
                        }
                        imageUrl={SummarySpeedImage}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.DistanciaRecorrida}
                        value={
                          isStationary && isIndividualReport
                            ? "N/A"
                            : behavior.DistanciaRecorrida
                        }
                        units={
                          isStationary && isIndividualReport ? "" : distanceUnit
                        }
                        imageUrl={SummaryTripsImage}
                      />
                    </Grid>
                  </Grid>
                </Paper>
              </GrowTransition>
            </Grid>
            {!isNoConsume && !isStationary && (
              <React.Fragment>
                <GrowTransition
                  in={!isLoading}
                  delay={sequence.next()}
                  duration={duration}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={3}
                    className="grid-item"
                  >
                    <MediaCard
                      title={lang.RendimientoBruto}
                      imageUrl={BrutePerformanceImage}
                      imageTitle={lang.RendimientoBruto}
                      value={behavior.RendimientoBruto}
                      units={`${distanceUnit}/${volumeUnit}`}
                      backgroundColor="transparent"
                      className="media-orange"
                    />
                  </Grid>
                </GrowTransition>
                <GrowTransition
                  in={!isLoading}
                  delay={sequence.next()}
                  duration={duration}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={3}
                    className="grid-item"
                  >
                    <MediaCard
                      title={lang.RendimientoEfectivo}
                      imageUrl={EfectivePerformanceImage}
                      imageTitle={lang.RendimientoEfectivo}
                      value={behavior.RendimientoEfectivo}
                      units={`${distanceUnit}/${volumeUnit}`}
                      backgroundColor="transparent"
                      className="media-orange"
                    />
                  </Grid>
                </GrowTransition>
                <GrowTransition
                  in={!isLoading}
                  delay={sequence.next()}
                  duration={duration}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={3}
                    className="grid-item"
                  >
                    <MediaCard
                      title={lang.TiempoMovimiento}
                      imageUrl={TimeMovingImage}
                      imageTitle={lang.TiempoMovimiento}
                      value={behavior.TiempoMovimiento}
                      backgroundColor="transparent"
                      className="media-orange"
                    />
                  </Grid>
                </GrowTransition>
                <GrowTransition
                  in={!isLoading}
                  delay={sequence.next()}
                  duration={duration}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={3}
                    className="grid-item"
                  >
                    <MediaCard
                      title={lang.TiempoMuerto}
                      imageUrl={DeadTimeImage}
                      imageTitle={lang.TiempoMuerto}
                      value={behavior.TiempoMuerto}
                      backgroundColor="transparent"
                      className="media-orange"
                    />
                  </Grid>
                </GrowTransition>
              </React.Fragment>
            )}

            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid container>
                <FilterTable
                  lang={lang}
                  data={performance}
                  columns={performanceReportColumns}
                  defaultPageSize={6}
                  showPagination={false}
                  tableHeader={lang.ReporteRendimiento}
                  filterable={false}
                />
              </Grid>
            </GrowTransition>
          </Grid>
        </div>
      )}

      {hasData && isIndividualReport && (
        <div className="root">
          <Grid container>
            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid container>
                <FilterTable
                  lang={lang}
                  data={events}
                  columns={eventsColumns}
                  defaultPageSize={5}
                  showPagination={true}
                  tableHeader={lang.CargasYDescargasFuel}
                  filterable={true}
                />
              </Grid>
            </GrowTransition>

            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="grid-item"
              >
                <Typography
                  variant="headline"
                  align="left"
                  color="primary"
                  className="headline"
                >
                  {lang.GraficaDeEventos}
                </Typography>
              </Grid>
            </GrowTransition>
            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="grid-item"
              >
                <Paper className="rounded">
                  <div style={{ height: "500px" }}>
                    <FuelChart
                      data={history}
                      max={maxVolume}
                      lang={lang}
                      volumeUnit={volumeUnit}
                    />
                  </div>
                </Paper>
              </Grid>
            </GrowTransition>

            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid container>
                <FilterTable
                  lang={lang}
                  data={history}
                  columns={historyColumns}
                  defaultPageSize={history.length < 5 ? history.length : 5}
                  showPagination={true}
                  tableHeader={lang.Historial}
                  filterable={true}
                />
              </Grid>
            </GrowTransition>
          </Grid>
        </div>
      )}

      {hasData && !isIndividualReport && (
        <div className="root">
          <Grid container>
            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid container>
                <FilterTable
                  lang={lang}
                  data={summaryBehavior}
                  columns={summaryBehaviorColumns}
                  defaultPageSize={
                    summaryBehaviorColumns.length < 5
                      ? summaryBehaviorColumns.length
                      : 5
                  }
                  showPagination={true}
                  tableHeader={lang.ResumenComportamientoCombustible}
                  filterable={true}
                />
              </Grid>
            </GrowTransition>

            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="grid-item"
              >
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                    className="grid-item"
                  >
                    <Grid container>
                      <FilterTable
                        lang={lang}
                        data={initialFuel}
                        columns={initialFuelColumns}
                        defaultPageSize={
                          initialFuel.length < 5 ? initialFuel.length : 5
                        }
                        showPagination={true}
                        tableHeader={lang.CombustibleInicial}
                        filterable={true}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                    className="grid-item"
                  >
                    <Grid container>
                      <FilterTable
                        lang={lang}
                        data={finalFuel}
                        columns={finalFuelColumns}
                        defaultPageSize={
                          finalFuel.length < 5 ? finalFuel.length : 5
                        }
                        showPagination={true}
                        tableHeader={lang.CombustibleFinal}
                        filterable={true}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </GrowTransition>

            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="grid-item"
              >
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                    className="grid-item"
                  >
                    <Grid container>
                      <FilterTable
                        lang={lang}
                        data={charges}
                        columns={chargesColumns}
                        defaultPageSize={
                          charges.length < 5 ? charges.length : 5
                        }
                        showPagination={true}
                        tableHeader={lang.CargasCombustible}
                        filterable={true}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                    className="grid-item"
                  >
                    <Grid container>
                      <FilterTable
                        lang={lang}
                        data={discharges}
                        columns={dischargesColumns}
                        defaultPageSize={
                          discharges.length < 5 ? discharges.length : 5
                        }
                        showPagination={true}
                        tableHeader={lang.DescargasCombustible}
                        filterable={true}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </GrowTransition>

            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="grid-item"
              >
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                    className="grid-item"
                  >
                    <Grid container>
                      <FilterTable
                        lang={lang}
                        data={iddleFuel}
                        columns={iddleColumns}
                        defaultPageSize={
                          iddleFuel.length < 5 ? iddleFuel.length : 5
                        }
                        showPagination={true}
                        tableHeader={lang.CombustibleRalenti}
                        filterable={true}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                    className="grid-item"
                  >
                    <Grid container>
                      <FilterTable
                        lang={lang}
                        data={consumedFuel}
                        columns={consumedColumns}
                        defaultPageSize={
                          consumedFuel.length < 5 ? consumedFuel.length : 5
                        }
                        showPagination={true}
                        tableHeader={
                          thereAreOnlyRegularUnits
                            ? lang.CombustibleConsumido
                            : thereAreNoRegularUnits
                            ? lang.CombustibleDesviado
                            : lang.CombustibleConsumidoDesviado
                        }
                        filterable={true}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </GrowTransition>
          </Grid>
        </div>
      )}
      <AlertMessage
        open={isAlertMessageOpen}
        message={alertMessage}
        handleClose={handleCloseAlertMessage}
      />
    </div>
  );
};

export default FuelView;



// WEBPACK FOOTER //
// ./src/containers/Fuel/FuelView.js